module.exports = __webpack_public_path__ + "img/unchecked.db763472.svg";